import registration from './register'
import updatePassword from './update-password'
import { profileFetch, profileUpdate, passwordUpdate, photoUpdate } from './profile'
import { initSession, login, logout } from './session'
import twitterLogin from './twitter'
import googleLogin from './google'
import { facebookLogin, facebookLoginError } from './facebook'
import initApp from './init-app'
import { changeAuthState, initAuthFlowParams } from './auth'
import { paymentGateway } from './payment-gateway'
import postMessage from './post-message'

export default function* mySaga() {
  yield [
    initApp(),
    registration(),
    updatePassword(),
    profileFetch(),
    profileUpdate(),
    photoUpdate(),
    passwordUpdate(),
    login(),
    logout(),
    twitterLogin(),
    googleLogin(),
    facebookLogin(),
    facebookLoginError(),
    changeAuthState(),
    initAuthFlowParams(),
    paymentGateway(),
    initSession(),
    postMessage()
  ]
}



// WEBPACK FOOTER //
// ./src/sagas/index.js